import * as Sentry from "@sentry/vue";

export function initSentry(Vue = null) {
    if (!process.env.MIX_SENTRY_LARAVEL_DSN) return;

    const config = { dsn: process.env.MIX_SENTRY_LARAVEL_DSN };
    if (Vue) {
        config.Vue = Vue;
    } else {
        config.integrations = (defaults) => defaults.filter(i => i.name !== 'Vue');
    }

    Sentry.init(config);
    window.Sentry = Sentry;
}